import React, { useState, useEffect, useContext } from "react";
import "../.././assets/css/article/ArticleDashboard.css";
import { imageArticleUrl } from "../../utils/modules";
import ArticleTrendChart from "./ArticleTrendChart";
import useArticles from "../../hooks/useArticle";
import ArticleBoostModal from "./ArticleBoostModal";
import ArticleDeleteModal from "./ArticleDeleteModal";
import ArticleUpdateModal from "./ArticleUpdateModal";
import ArticleNotInterressedModal from "./ArticleNotInterressedModal";
import useCategorie from "../../hooks/useCategorie";
import useStripePaiement from "../../hooks/useStripePaiement";
import noImage from "../../assets/images/articles/no-photo.png";
import { AuthContext } from "../../contexts/AuthContext.js";
import { useNavigate, useLocation } from "react-router-dom";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";

const ArticleDashboard = ({ article, setArticle, formatPrice, setAlert }) => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [activeMetric, setActiveMetric] = useState("vues");
  // RESAKA BOOST
  const [showModalBoost, setShowModalBoost] = useState(false);
  const [boostLoading, setBoostLoading] = useState(false);
  const [currentBoostId, setCurrentBoostId] = useState(null);

  // RESAKA DELETE
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [currentDeleteId, setCurrentDeleteId] = useState(null);

  // RESAKA UPDATE
  const { getAllCategories } = useCategorie();
  const [isLoadingCategorie, setIsLoadingCategorie] = useState(false);
  const [categories, setCategories] = useState([]);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [updateLoading, setUpdateLoading] = useState(false);
  const [formArticle, setFormArticle] = useState({
    oldPhotos: [],
    photos: [],
  });
  const [infoCle, setInfoCle] = useState([]);

  //INFORMATION MOBILE MONEY
  const [formPaiement, setFormpaiement] = useState({});
  const [paymentMethods, setPaymentMethods] = useState("cb");
  // FONCTION IRAISANA
  const { updateArticleStatus, updateArticle, findOneArticle } = useArticles();
  const { createPaiement } = useStripePaiement();
  const location = useLocation();
  const [articlePlusInteresse, setArticlePlusInteresse] = useState(null);
  const [showPlusInteresseModal, setShowPlusInteresseModal] = useState(false);

  useEffect(() => {
    setIsLoadingCategorie(true);
    getAllCategories()
      .then((res) => {
        if (res?.data?.data && res?.data?.data.length > 0) {
          setCategories(res.data.data);
        }
        setIsLoadingCategorie(false);
      })
      .catch((err) => {
        setIsLoadingCategorie(false);
        console.log(err);
      });
  }, []);

  const openDeleteModal = (id) => {
    setCurrentDeleteId(id);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    if (!currentDeleteId) return;

    try {
      setDeleteLoading(true);

      const res = await updateArticleStatus(currentDeleteId, "archive", 1)
        .then((res) => {})
        .catch((err) => console.log(err));

      if (res) {
        setAlert?.({
          message: "Annonce supprimée avec succès",
          type: "success",
        });
      }
      setShowDeleteModal(false);
      setCurrentDeleteId(null);
      navigate("/utilisateur/mesAnnonces");
    } catch (error) {
      console.error(error);
      setAlert?.({
        message: "Erreur lors de la suppression",
        type: "danger",
      });
    } finally {
      setDeleteLoading(false);
    }
  };

  const handleUpdateChange = (e) => {
    const { name, value } = e.target;

    setFormArticle((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleUpdatePhotos = (e) => {
    const files = Array.from(e.target.files);

    const maxPhotos = Number(formArticle.typeAbonnement) === 1 ? 10 : 2;
    const total = formArticle.oldPhotos.length + files.length;

    if (total > maxPhotos) {
      return setAlert?.({
        message: `Vous ne pouvez pas ajouter plus de ${maxPhotos} photos.`,
        type: "danger",
      });
    }

    setFormArticle((prev) => ({
      ...prev,
      photos: files,
    }));
  };

  const handleRemoveOldPhoto = (index) => {
    setFormArticle((prev) => {
      const updated = [...prev.oldPhotos];
      updated.splice(index, 1);
      return { ...prev, oldPhotos: updated };
    });
  };

  const handleRemoveNewPhoto = (index) => {
    setFormArticle((prev) => {
      const updated = [...prev.photos];
      updated.splice(index, 1);
      return { ...prev, photos: updated };
    });
  };

  const maxPhotos = Number(formArticle.typeAbonnement) === 1 ? 10 : 2;
  const remainingPhotos = maxPhotos - (formArticle.oldPhotos?.length || 0);

  const handleConfirmUpdate = async () => {
    setUpdateLoading(true);

    const fd = new FormData();

    Object.keys(formArticle).forEach((key) => {
      if (key === "infoCle") {
        fd.append("infoCle", JSON.stringify(infoCle));
      } else if (key !== "photos" && key !== "oldPhotos") {
        fd.append(key, formArticle[key]);
      }
    });

    formArticle.photos?.forEach((p) => fd.append("photos", p));
    fd.append("existingPhotos", JSON.stringify(formArticle.oldPhotos || []));

    try {
      await updateArticle(formArticle._id, fd)
        .then((res) => {})
        .catch((err) => console.log(err));
      setShowUpdateModal(false);
      setArticle(formArticle);
      setAlert?.({ message: "Annonce modifiée avec succès", type: "success" });
    } catch (err) {
      console.error(err);
      setAlert?.({ message: "Erreur lors de la modification", type: "danger" });
    } finally {
      setUpdateLoading(false);
    }

    await findOneArticle(formArticle._id)
      .then((res) => {
        if (!res?.data?.data) return;
        setArticle(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // INFO ANLE BOOST
  const prixBoost = 4000;

  const now = new Date();
  const expirationDate = new Date(article.dateExpiration);
  const isExpired = expirationDate < now;
  const isNotInterested = article.status === 4; // Vérifie si le statut est "N'est plus intéressé"
  const isSale = article.status === 3;

  const confirmNotInterested = async (articleId) => {
    try {
      await updateArticleStatus(articleId, "status", 4);
      setAlert?.({
        message: "Annonce marquée comme 'N'est plus intéressé' avec succès",
        type: "success",
      });
      setShowPlusInteresseModal(false);
      setArticlePlusInteresse(null);
      navigate("/utilisateur/mesAnnonces");
    } catch (error) {
      console.error(error);
      setAlert?.({
        message: "Erreur lors de la mise à jour du statut",
        type: "danger",
      });
    }
  };

  return (
    <>
      <div className="dashboard_container">
        <div className="dashboard_article_card">
          <div className="dashboard_article_header">
            <div className="dashboard_article_image">
              <img
                src={
                  article.photos?.[0]
                    ? `${imageArticleUrl}/${article.photos[0]}?v=${Date.now()}`
                    : noImage
                }
                alt=""
              />
            </div>
            <div className="dashboard_article_info">
              <h3 className="text-uppercase">{article.titre}</h3>
              {article?.prix && article.prix > 0 ? (
                <p className="dashboard_article_price text-uppercase">
                  {formatPrice(article.prix)} MGA
                </p>
              ) : null}
              <p className="dashboard_article_location text-uppercase">
                {article.ville}
              </p>
              <p className="dashboard_article_date">
                {new Date(article.createdAt).toLocaleDateString()}
              </p>
              <>
                {isSale ? (
                  <>
                    <p className="text_vendu_dashboard">VENDU</p>
                  </>
                ) : isNotInterested ? (
                  <p className="text_not_interrest">N'est plus intéressé</p>
                ) : isExpired ? (
                  <>
                    <button
                      className="btn btn_reabonner"
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(
                          `/article/abonnement/paiement?type=2&&id=${article._id}`,
                        );
                      }}
                      style={{ marginTop: 8 }}
                    >
                      Réabonner
                    </button>

                    <button
                      className="btn btn_not_interested"
                      onClick={(e) => {
                        e.stopPropagation();
                        setArticlePlusInteresse(article);
                        setShowPlusInteresseModal(true);
                      }}
                      style={{ marginTop: 8, marginLeft: 8 }}
                    >
                      N'est plus intéressé
                    </button>
                  </>
                ) : (
                  <div className="dashboard_article_action">
                    <a
                      href="#"
                      className="dashboard_article_action_link"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate(`/article/modification?id=${article?._id}`, {
                          state: { from: location.pathname + location.search },
                        });
                      }}
                    >
                      Modifier
                    </a>
                    <a
                      className="dashboard_article_action_link"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        openDeleteModal(article._id);
                      }}
                    >
                      Supprimer
                    </a>
                    <a
                      className="dashboard_article_action_link"
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(
                          `/article/abonnement/paiement?type=3&&id=${article?._id}`,
                        );
                      }}
                    >
                      Booster
                    </a>
                  </div>
                )}
              </>
            </div>
            <div className="separeteur_verticale"></div>
            <div className="dashboard_article_stat">
              <div className="dashboard_article_stat_icon">
                <i className="bi bi-eye"></i>{" "}
                <span>{article?.nbVueCount || 0}</span>
              </div>
              <div className="dashboard_article_stat_icon">
                <i className="bi bi-heart"></i>{" "}
                <span>{article?.nbFavorisCount || 0}</span>
              </div>
              <div className="dashboard_article_stat_icon">
                <i className="bi bi-envelope"></i>{" "}
                <span>{article?.nbMessageCount || 0}</span>
              </div>
              <div className="dashboard_article_stat_icon">
                <i className="bi bi-telephone"></i>{" "}
                <span>{article?.nbAppelCount || 0}</span>
              </div>
              <div className="dashboard_article_stat_icon">
                <i className="bi bi-whatsapp"></i>{" "}
                <span>{article?.nbWhatsAppCount || 0}</span>
              </div>
            </div>
          </div>

          <div className="dashboard_article_chart">
            <div className="separeteur_horizentale"></div>
            <h4 style={{ margin: "30px 0" }}>Tendance de votre annonce</h4>

            <div className="dashboard_article_chart_layout">
              <div className="dashboard_article_chart_sidebar">
                {["vues", "favoris", "messages", "appels","whatsApp"].map((m) => (
                  <div
                    key={m}
                    className={`dashboard_article_chart_metric ${activeMetric === m ? "active" : ""}`}
                    onClick={(e) => {
                      e.preventDefault();
                      setActiveMetric(m);
                    }}
                  >
                    <span className="icon">
                      <i
                        className={`bi bi-${m === "vues" ? "eye" : m === "favoris" ? "heart" : m === "messages" ? "envelope" : m==="whatsApp" ? "whatsapp": "telephone"}`}
                      ></i>
                    </span>
                    <p className="label">
                      {m.charAt(0).toUpperCase() + m.slice(1)}
                    </p>
                  </div>
                ))}
              </div>

              <div className="dashboard_article_chart_container">
                <ArticleTrendChart
                  article={article}
                  activeMetric={activeMetric}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <ArticleBoostModal
        show={showModalBoost}
        loading={boostLoading}
        onClose={() => {
          setShowModalBoost(false);
          setCurrentBoostId(null);
        }}
        formPaiement={formPaiement}
        setFormpaiement={setFormpaiement}
        prixBoost={prixBoost}
        paymentMethods={paymentMethods}
        setPaymentMethods={setPaymentMethods}
      />

      <ArticleDeleteModal
        show={showDeleteModal}
        loading={deleteLoading}
        onClose={() => {
          setShowDeleteModal(false);
          setCurrentDeleteId(null);
        }}
        onConfirm={confirmDelete}
      />

      <ArticleUpdateModal
        show={showUpdateModal}
        updateLoading={updateLoading}
        formArticle={formArticle}
        setFormArticle={setFormArticle}
        infoCle={infoCle}
        categories={categories}
        maxPhotos={maxPhotos}
        remainingPhotos={remainingPhotos}
        onChange={handleUpdateChange}
        onPhotosChange={handleUpdatePhotos}
        onRemoveOldPhoto={handleRemoveOldPhoto}
        onRemoveNewPhoto={handleRemoveNewPhoto}
        onClose={() => setShowUpdateModal(false)}
        onConfirm={handleConfirmUpdate}
        setInfoCle={setInfoCle}
      />

      {showPlusInteresseModal && articlePlusInteresse && (
        <ArticleNotInterressedModal
          article={articlePlusInteresse}
          confirmNotInterested={confirmNotInterested}
          setShowPlusInteresseModal={setShowPlusInteresseModal}
        />
      )}
    </>
  );
};

export default ArticleDashboard;
